<div class="flex flex-col gap-4">
  <div>
    <div class="text-muted-color">{{ transaction()._id }}</div>
    <div>{{ transaction().location }}</div>
    @if (username()) {
      <div>{{ username() }}</div>
    }

    <div>
      <span>{{ transaction().startdate | date: 'dd.MM.yyy' }}&nbsp;-&nbsp;</span>
      @if (transaction().enddate) {
        <span>{{ transaction().enddate | date: 'dd.MM.yyy' }}</span>
      } @else {
        <span>{{ 'general.now' | translate }}</span>
      }
    </div>
  </div>

  <barcode-scanner-search-field (onCode)="codeScanned($event)" [disabled]="true"></barcode-scanner-search-field>

  <div class="flex flex-col gap-2 bg-neutral-800 rounded-sm p-2">
    <div class="flex flex-row gap-4 items-center">
      <div class="text-lg font-bold">{{ 'internal.inventory.items' | translate }}</div>
      @if (additionalReturns() > 0) {
        <span class="italic text-muted-color">{{additionalReturns()}} {{'internal.inventory.transactionEdit.additionalReturned' | translate}}</span>
      }
      <span class="ml-auto">{{'internal.inventory.transactionEdit.isAddNew' | translate}}</span>
      <p-toggleswitch [(ngModel)]="isAddNew" (change)="search.focus()" />
    </div>

    <div class="h-1 bg-neutral-950"></div>

    <div class="flex flex-col gap-2">
      @if (loadingTransaction()) {
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
        <p-skeleton height="2.5rem" />
      } @else {
        @for (item of itemTypes(); track item._id) {
          <div
            class="item pt-2 rounded-sm"
            [class.returned]="itemComplete(item._id)"
            [class.shaking]="typeShaking(item._id)"
            #typeElements
          >
            <div
              class="flex flex-row items-center gap-2 cursor-pointer"
              (click)="toggleCollapse(item._id)"
            >
              <mat-icon color="white">
                {{ collapsedTypes()[item._id] ? 'expand_more' : 'expand_less' }}
              </mat-icon>
              <span class="item-count">{{ itemTypesCount()[item._id] }}x </span>
              <span class="font-semibold">{{ item.name }}</span>
              @if (item.additionalInfo) {
                <div class="ml-4 text-sm text-muted-color">{{ item.additionalInfo }}</div>
              }
            </div>
            <div
              class="instance-list flex flex-col mt-2 ml-4"
              [class.collapsed]="collapsedTypes()[item._id]"
            >
              @for (instance of itemFilter(item._id); track instance.instanceid) {
                <div
                  class="instance flex flex-row items-center h-9 rounded-sm"
                  [class.returned]="instance.back"
                  [class.deleted]="instanceDeleted(item._id, instance.instanceid)"
                  [class.updating]="instanceUpdating(item._id, instance.instanceid)"
                  [class.shaking]="instanceShaking(item._id, instance.instanceid)"
                  [attr.id]="instance.itemid + '-' + instance.instanceid"
                  #instanceElements
                >
                  <div class="ml-2 text-base font-semibold">{{ item.name }}</div>
                  <div class="ml-4 text-sm text-muted-color">{{ instance.instanceid }}</div>
                  <div class="ml-4">
                    {{
                      (instance.back
                        ? 'internal.inventory.returned'
                        : 'internal.inventory.notReturned'
                      ) | translate
                    }}
                  </div>
                  @if (instanceDeleted(item._id, instance.instanceid)) {
                    <div class="ml-4">{{ 'internal.inventory.deleted' | translate }}</div>
                  }
                  <div class="ml-auto flex flex-row justify-end items-center gap-2">
                    @if (instanceUpdating(item._id, instance.instanceid)) {
                      <p-progress-spinner
                        strokeWidth="8"
                        fill="transparent"
                        animationDuration="1s"
                        [style]="{ width: '18px', height: '18px' }"
                      />
                    }
                    <p-button
                      [pt]="{ root: { style: { padding: '4px' } } }"
                      [rounded]="true"
                      [text]="true"
                      (onClick)="printLabel(item, instance)"
                    >
                      <mat-icon color="white"> print </mat-icon>
                    </p-button>
                    <p-button
                      [pt]="{ root: { style: { padding: '4px' } } }"
                      [rounded]="true"
                      [text]="true"
                      (onClick)="selectItem(item, [instance.instanceid])"
                    >
                      <mat-icon color="white"> visibility </mat-icon>
                    </p-button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
</div>
